import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  selectCurrentUser,
  selectIsAuthenticated,
  selectAuthLoading,
  selectAuthError,
  selectIsAdmin,
} from '@/features/auth/authSelectors'
import { loginThunk, logoutThunk, clearError } from '@/features/auth/authSlice'
import { ROUTES } from '@/constants/routes'

export function useAuth() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const user          = useSelector(selectCurrentUser)
  const isAuth        = useSelector(selectIsAuthenticated)
  const isLoading     = useSelector(selectAuthLoading)
  const error         = useSelector(selectAuthError)
  const isAdmin       = useSelector(selectIsAdmin)

  const login = async (email, password) => {
    const result = await dispatch(loginThunk({ email, password }))
    if (loginThunk.fulfilled.match(result)) {
      navigate(ROUTES.DASHBOARD)
    }
    return result
  }

  const logout = async () => {
    await dispatch(logoutThunk())
    navigate(ROUTES.LOGIN)
  }

  const dismissError = () => dispatch(clearError())

  return { user, isAuth, isLoading, error, isAdmin, login, logout, dismissError }
}
